var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",class:{
      widgetSelected: _vm.isSelected
  },style:({
  top: ((_vm.content.y) + "px"),
  left: ((_vm.content.x) + "px"),
  position: 'fixed',
  zIndex: _vm.index,
  fontFamily: _vm.content.mainFont,
  fontSize: ((_vm.content.mainFontSize) + "px"),
  backgroundColor: (_vm.content.backgroundColor && _vm.content.backgroundColor.hexa) ? _vm.content.backgroundColor.hexa : null,
  color: (_vm.content.foreGroundColor && _vm.content.foreGroundColor.hexa) ? _vm.content.foreGroundColor.hexa : null,
  transform: _vm.content.transform,
      width: ((_vm.content.width || 200) + "px"),
      height: _vm.content.height ? ((_vm.content.height) + "px") : null,
  })},[_c('div',{class:{
         'edit-overlay':true,
          selected: _vm.isSelected
    },attrs:{"tabindex":"1"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }